define([
    "dojo/_base/declare",
    "dojo/_base/event",
    "dojo/dom",
    "dojo/dom-attr",
    "dojo/dom-class",
    "dojo/dom-style",
    "dojo/has",
    "dojo/mouse",
    "dojo/on",
    "dojo/touch",
    "dijit/_TemplatedMixin",
    "dijit/_WidgetBase",
    "./LayoutChildProperty",
    "./LayoutContainerEvent",
    "./LayoutUtils",
    "dojo/text!./templates/Tab.html"
], function (declare, event, dom, domAttr, domClass, domStyle, has, mouse, on, touch, _TemplatedMixin, _WidgetBase,
             LayoutChildProperty, LayoutContainerEvent, LayoutUtils, TabTemplate) {

    /**
     * Defines an individual tab class
     */
    return declare([_WidgetBase, _TemplatedMixin], {

        templateString: TabTemplate,

        buildRendering: function () {
            var that = this;
            this.inherited(arguments);

            this._setLabelAttr(this.label);
            this._setToolTipAttr(this.toolTip);
            this._setEnabledAttr(this.enabled);
            if (!this.closable && this.closeNode) {
                domStyle.set(this.closeNode, {display: "none"});
            }

            dom.setSelectable(this.domNode, false);
            LayoutUtils.preventFocus(this.domNode, true);

            on(this.domNode, touch.press, function (e) {
                if (e.target === that.closeNode) {
                    that.isCloseArmed = true;
                } else {
                    that.isArmed = true;
                }
                that.releaseConnection = on(that.ownerDocument, touch.release, function () {
                    that.isCloseArmed = false;
                    that.isArmed = false;
                    that.releaseConnection.remove();
                });
                LayoutUtils.stopEvent(e);
            });

            on(this.domNode, touch.release, function (e) {
                if (mouse.isRight(e)) {
                    return;
                }
                if (mouse.isMiddle(e)) {
                    if ((that.isArmed || that.isCloseArmed) && that.closable && !has("ie")) {
                        that.emit(LayoutContainerEvent.CLOSE, that);
                    }
                } else if (e.target === that.closeNode) {
                    if (that.isCloseArmed) {
                        that.emit(LayoutContainerEvent.CLOSE, that);
                    }
                } else if (that.isArmed && that.enabled !== false) {
                    that.set("checked", true);
                    if (that.properties.isSelectable !== false) {
                        that.properties.set(LayoutChildProperty.IS_SELECTED, true);
                    }
                }
            });

            if (this.checked) {
                domClass.add(this.domNode, "checkedTab");
            }
        },

        disarm: function () {
            this.isArmed = false;
        },

        _setLabelAttr: function (label) {
            if (this.labelNode) {
                this.labelNode.textContent = label;
            }
            this._set("label", label);
        },

        _getLabelAttr: function () {
            return this.labelNode ? this.labelNode.textContent : "";
        },

        _setToolTipAttr: function (toolTip) {
            if (toolTip) {
                domAttr.set(this.domNode, "title", toolTip);
            } else {
                domAttr.remove(this.domNode, "title");
            }
            this._set("toolTip", toolTip);
        },

        _setCheckedAttr: function (checked) {
            if (this.checked !== checked || !this._started) {
                this._set("checked", checked);
                if (checked) {
                    domClass.add(this.domNode, "checkedTab");
                } else {
                    domClass.remove(this.domNode, "checkedTab");
                }
                if (this.domNode.getAttribute("role") === "tab") {
                    this.domNode.setAttribute("aria-selected", checked);
                }
            }
        },

        _setClosableAttr: function (closable) {
            if (this.closable !== closable || !this._started) {
                this._set("closable", closable);
                if (this.closeNode) {
                    domStyle.set(this.closeNode, {display: closable ? "inline" : "none"});
                }
            }
        },

        _setEnabledAttr: function (enabled) {
            if (this.enabled !== enabled || !this._started) {
                this._set("enabled", enabled);
                if (enabled) {
                    domClass.remove(this.domNode, "disabled");
                } else {
                    domClass.add(this.domNode, "disabled");
                }
            }
        }
    });
});
